import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  title: () => i18n.t(i18nKeys.bankOnboarding__title),
  titleSubSection: () => i18n.t(i18nKeys.bankOnboarding__titleSubSection),
  bankFormTitle: () => i18n.t(i18nKeys.bankOnboarding__bankFormTitle),
  routingNumber: () => i18n.t(i18nKeys.bankOnboarding__routingNumber),
  bsbCode: () => i18n.t(i18nKeys.bankOnboarding__bsbCode),
  checkingAccountNumber: () =>
    i18n.t(i18nKeys.bankOnboarding__checkingAccountNumber),
  whereToFindNumbers: () => i18n.t(i18nKeys.bankOnboarding__whereToFindNumbers),
  errorMessageRoutingAccount: () =>
    i18n.t(i18nKeys.bankOnboarding__errorMessageRoutingAccount),
  errorMessageBSBCodeAccount: () =>
    i18n.t(i18nKeys.bankOnboarding__errorMessageBSBCodeAccount),
  errorMessageTransitAccount: () => i18n.t(i18nKeys.bankOnboarding__bankOnboarding__errorMessageTransitAccount),
  submit: () => i18n.t(i18nKeys.bankOnboarding__submit),
  goBack: () => i18n.t(i18nKeys.bankOnboarding__goBack),
  noBankButton: () => i18n.t(i18nKeys.bankOnboarding__noBankButton),
  noBankModalCopy1: () => i18n.t(i18nKeys.bankOnboarding__noBankModalCopy1),
  noBankModalCopy2: () => i18n.t(i18nKeys.bankOnboarding__noBankModalCopy2),
  noBankModalTitle: () => i18n.t(i18nKeys.bankOnboarding__noBankModalTitle),
  noBankModalPrimaryAction: () =>
    i18n.t(i18nKeys.bankOnboarding__noBankModalPrimaryAction),
  branchNumber: () => i18n.t(i18nKeys.bankOnboarding__branchNumber),
  financialInstitutionNumber: () => i18n.t(i18nKeys.bankOnboarding__financialInstitutionNumber),
  accountNumber: () => i18n.t(i18nKeys.bankOnboarding__accountNumber),
  whereToFindTransitNumber: () => i18n.t(i18nKeys.bankOnboarding__whereToFindTransitNumber)
}
